import DatePickerRange from './src/index.vue'

DatePickerRange.install = (Vue) => {
  Vue.component(DatePickerRange.name, DatePickerRange)
}

export default DatePickerRange
